import { useContext, useState } from 'react'
import axios from 'axios'

import './signup.css'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../Routes/Routes1'


function submitData(userData,msg,dispatch){
    const PORT=process.env.REACT_APP_URL_PORT
    axios.post(`https://${PORT}/admin/user`,userData)
    .then((res)=>{
        alert(msg)
        localStorage.setItem("sangeetUser",JSON.stringify(res.data))
        dispatch({type:"USER",payload:true})
    })
}

function validation(userData){
    if(userData.name !== '' && userData.dob !== '' && userData.email !== '' && 
    userData.password !== '' && userData.rPassword !== '' ){
        if(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(userData.email)){
            if(userData.password.length>=8){
                if(userData.password===userData.rPassword){
                    return {valid:true,msg:'Successfully registered'}
                }
                else{
                    return {valid:false,msg:'Re-entered password are wrong!'}
                }
            }
            else{
                return {valid:false,msg:'Please enter minimum 8 characters password'}
            }
        }
        else{
            return {valid:false,msg:'Invalid email address'}
        }
    }
    else{
        return {valid:false,msg:'please fill all the input fields'}
    }
}

export default function Signup(){
    const [userInput,setUserInput]=useState({name:'',dob:'',email:'',password:'',rPassword:''})
    const {state,dispatch}=useContext(UserContext)
    const [loading,setLoading]=useState(false)
    const navigate=useNavigate()
    const PORT=process.env.REACT_APP_URL_PORT

    if(state){
        navigate('/')
    }
    function changeHandle(e){
        setUserInput({...userInput,[e.target.name]:e.target.value})
    }
    function registerUserData(){
        setLoading(true)
        const validation_state=validation(userInput)
        if(validation_state.valid){
            axios.post(`https://${PORT}/admin/user_search`,{id: userInput.email})
            .then(res=>{ 
                if(res.data===""){
                    submitData(userInput,validation_state.msg,dispatch)
                }
                else{
                    alert("Email address is already registered")
                    setLoading(false)
                }
            })
        }
        else{
            alert(validation_state.msg)
            setLoading(false)
        }
        
    }
   const  _onFocus= (e)=>{
        e.currentTarget.type = "date";
    }

    return(
        <div className="row mt-5">
            <div className="col-md-4 mt-3"></div>
            <div className="col-md-4 sim">
                <center>
                    <h5 className="mt-5">Sign Up</h5>
                    <input type="text" placeholder="Name" name='name' onChange={changeHandle}/><br/>
                    <input type="text" onFocus={_onFocus} placeholder="What is your date of birth?" name='dob' onChange={changeHandle}/><br/>
                    <input type="email" placeholder="E-mail" name='email' onChange={changeHandle}/><br/>
                    <input type="password" placeholder="Password" name='password' onChange={changeHandle}/><br/>
                    <input type="password" placeholder="Re-enter Password" name='rPassword' onChange={changeHandle}/><br/>
                    <button type="submit" className="btn btn-dark btn-sm" onClick={registerUserData} disabled={loading}>Submit</button>
                </center>
            </div>
            <div className="col-md-4"></div>
        </div>
    )
}